(function() {
    'use strict';
    angular
        .module('doctorclubboApp')
        .factory('QueueType', QueueType);

    QueueType.$inject = ['$resource'];

    function QueueType ($resource) {
        var resourceUrl =  'api/queue-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
